import React from 'react';

export const ModernInvoicePageAsepasaConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['master', 'rh', 'rh_not_signer', 'director', 'funcionario'],
    routes  : [
        {
            path     : '/invoice-asepasa/:id?/:status?/:message?',
            component: React.lazy(() => import('./ModernInvoicePage'))
        }
    ]
};
